import React from "react"

export const LinkedIn = () => {
    return (
        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_571)">
                <path d="M14.9756 0C7.23129 0 0.951172 6.28012 0.951172 14.0244C0.951172 21.7687 7.23129 28.0488 14.9756 28.0488C22.7198 28.0488 29 21.7687 29 14.0244C29 6.28012 22.7198 0 14.9756 0ZM10.9002 21.2009H7.48466V10.9251H10.9002V21.2009ZM9.19256 9.52193H9.1703C8.02414 9.52193 7.28286 8.73293 7.28286 7.74684C7.28286 6.7385 8.04683 5.97132 9.21524 5.97132C10.3837 5.97132 11.1027 6.7385 11.1249 7.74684C11.1249 8.73293 10.3837 9.52193 9.19256 9.52193ZM23.2161 21.2009H19.8009V15.7036C19.8009 14.3221 19.3064 13.3798 18.0706 13.3798C17.1271 13.3798 16.5651 14.0154 16.3182 14.6289C16.2279 14.8485 16.2058 15.1554 16.2058 15.4624V21.2009H12.7905C12.7905 21.2009 12.8352 11.8891 12.7905 10.9251H16.2058V12.3801C16.6597 11.6799 17.4718 10.6839 19.2839 10.6839C21.5311 10.6839 23.2161 12.1526 23.2161 15.3088V21.2009Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1_571">
                    <rect width="28.0488" height="28.0488" fill="white" transform="translate(0.951172)" />
                </clipPath>
            </defs>
        </svg>
    )
}